module.exports = __webpack_public_path__ + "static/media/opsmatic-newrelic.5c584d1b.png";